import { isLocalMode } from "./appMode";

/**
 * Broker (api.rago.tv) base resolution.
 * - hosted dev: same-origin "" — the Vite proxy forwards /v1, /healthz,
 *   /readyz to localhost:8080 so the rago_tv_* cookies land on localhost
 *   exactly as they land on rago.tv in production.
 * - hosted prod: https://api.rago.tv (cross-origin, exact-origin CORS +
 *   credentials so Set-Cookie is honoured; the credential is the Bearer).
 * - local mode (the server-embedded app): always absolute — the page's own
 *   origin is the media server, so the broker is cross-origin in dev and
 *   prod alike (no cookies; the session token lives in localStorage).
 *   VITE_API_BASE points a `dev:local` run at a dev broker.
 */
const configured = import.meta.env.VITE_API_BASE as string | undefined;

export const API_BASE: string =
  configured ?? (import.meta.env.DEV && !isLocalMode ? "" : "https://api.rago.tv");

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}
